module.exports = __webpack_public_path__ + "img/isometrico.d9bb4d73.jpg";